var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIronstoneTitleOnly(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 9,
    viewBox: "0 0 78 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.613039 0.00558567H0V8.98584H2.79668V2.18923L0.613039 0.00558567Z",
    fill: "#243847"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.68455 3.94357H9.80064V2.26299H8.68455V3.94357ZM11.4941 0.0050993C12.1483 0.0050993 12.6102 0.466947 12.6102 1.1212V4.64917C12.6102 5.07254 12.2894 5.54721 11.8661 5.66264L12.7513 7.86922V8.98535H10.0059L9.24899 6.18867H8.68455V8.98535H5.875V0.0050993H11.4941Z",
    fill: "#243847"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3837 6.74029H19.4998V2.26299H18.3837V6.74029ZM16.7032 8.98535C16.036 8.98535 15.5742 8.5235 15.5742 7.86922V1.1212C15.5742 0.466947 16.036 0.0050993 16.7032 0.0050993H21.1804C21.8475 0.0050993 22.3094 0.466947 22.3094 1.1212V7.86922C22.3094 8.5235 21.8475 8.98535 21.1804 8.98535H16.7032Z",
    fill: "#243847"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9453 3.00757V1.12172C34.9453 0.467466 35.4071 0.00558567 36.0742 0.00558567H40.9492V1.10889L40.5131 2.26351H37.7549V2.67404L40.1924 4.30328C40.8081 4.71381 40.9492 5.11154 40.9492 5.82994V7.86974C40.9492 8.52402 40.4874 8.98584 39.8331 8.98584H34.9453V6.74078H38.1397V6.15067L35.7022 4.53423C35.0864 4.11084 34.9453 3.726 34.9453 3.00757Z",
    fill: "#243847"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3887 2.26348V0.00558567H49.6748V1.12169L49.2258 2.26348H47.8788V8.98584H45.0693V2.26348H43.3887Z",
    fill: "#243847"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1767 6.74029H56.2928V2.26299H55.1767V6.74029ZM53.4961 8.98535C52.829 8.98535 52.3672 8.5235 52.3672 7.86922V1.1212C52.3672 0.466947 52.829 0.0050993 53.4961 0.0050993H57.9734C58.6405 0.0050993 59.1023 0.466947 59.1023 1.1212V7.86922C59.1023 8.5235 58.6405 8.98535 57.9734 8.98535H53.4961Z",
    fill: "#243847"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9961 8.98584V0.00558567H78V1.12172L77.551 2.26348H74.7928V3.26415H77.551V5.50921H74.7928V6.74078H78V8.98584H71.9961Z",
    fill: "#243847"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4043 0.00694752V0.692022L29.764 3.26426L31.9957 5.7041V2.30018L29.8523 0.00694752H29.4043Z",
    fill: "#243847"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9774 0.0153513H25.2598V8.99561H27.8384V7.87947L27.4792 4.85186H27.6973L29.0187 8.99561H31.995V6.48328L29.5044 3.78067L25.9774 0.0153513Z",
    fill: "#243847"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3262 0.00011158V0.685186L66.6859 3.25742L68.9176 5.69727V2.29335L66.7742 0.00011158H66.3262Z",
    fill: "#F6B90F"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8993 0.0099802H62.1816V8.99023H64.7603V7.8741L64.401 4.84649H64.6192L65.9405 8.99023H68.9168V6.47791L66.4263 3.77529L62.8993 0.0099802Z",
    fill: "#243847"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIronstoneTitleOnly);
export default __webpack_public_path__ + "static/media/ironstone_title_only.c2bf7580b6b8fb6f6db35494682ccee8.svg";
export { ForwardRef as ReactComponent };